module.exports = __webpack_public_path__ + "img/titanium-ore.85762f46.png";